import GoodsRecordManage from "./goodsRecordManage";

export default GoodsRecordManage;
